import { cartFields } from '@pylot-data/core-queries/cart'

export const setShippingAddressesMutation = /* GraphQL */ `
    mutation setShippingAddressesOnCart($input: SetShippingAddressesOnCartInput!, $isSignedIn: Boolean = false) {
        setShippingAddressesOnCart(input: $input){
            cart {
                ${cartFields}
            }
        }
    }
`
